import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "regulation" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "regulation-shadow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", {
      class: "regulation-content",
      innerHTML: _ctx.dataRule
    }, null, 8, ["innerHTML"])
  ]))
}